// 神策埋点
import Sensors from 'sa-sdk-javascript';
import { getUrlQuery } from '@frontend/doraemon';
import { Base64 } from 'js-base64';
import { currPageInfo, ProductCategory } from './route-info';
import { getAppProductName } from './helper';
import { ILocalStorageKey } from '@/utils/local-storage';

// 神策secondId 即为 编程猫userId
const sensorsSecondId = localStorage.getItem(ILocalStorageKey.USER_ID);

(async() => {
  // 神策初始化
  Sensors.init({
    // 判断是否在App内
    app_js_bridge: !!getAppProductName(),
    show_log: true,
    server_url: window.CODEMAOCONFIG.host.track,
    is_track_single_page: true, // 单页面配置，默认开启，若页面中有锚点设计，需要将该配置删除，否则触发锚点会多触发 $pageview 事件
    use_client_time: true,
    send_type: 'beacon',
    heatmap: {
      // 是否开启点击图，default 表示开启，自动采集 $WebClick 事件，可以设置 'not_collect' 表示关闭。
      clickmap: currPageInfo?.notCollectClick ? 'not_collect' : 'default',
      // 是否开启触达注意力图，not_collect 表示关闭，不会自动采集 $WebStay 事件，可以设置 'default' 表示开启。
      scroll_notice_map: 'default',
      collect_tags: {
        div: true,
        span: true,
        img: true,
        li: true,
      },
    },
  });

  // 设置全局参数
  Sensors.registerPage({
    $url_path: location.href,
    $referrer: document.referrer,
    $utm_source: getUrlQuery().utm_source || '',
    $utm_term: getUrlQuery().utm_term || '',
    $utm_content: getUrlQuery().utm_content || '',
    $title: currPageInfo.title,
    product_name: getAppProductName() ?? currPageInfo.category,
    project_name: 'octopus-marketing',
  });

  if (sensorsSecondId) {
    Sensors.login(sensorsSecondId);
  }

  Sensors.quick('autoTrack'); // 用于采集 $pageview 事件。
})();


// 自定义上报事件,统一入口,用于统一处理全局参数
export const reportSensorsEvent = (productName:ProductCategory, eventName:string, params:object = {}) => {
  const commonParams:any = {
    product_name: getAppProductName() ?? productName,
  };
  if (currPageInfo.title) {
    commonParams.$title = currPageInfo.title;
  }
  sensors.track(eventName, {
    ...params,
    ...commonParams,
  });
};

// 神策SDK实体
export const sensors = Sensors;

// 登录注册接口添加数据
export const getSensorsData = () => {
  const anonymousId = Sensors.quick('getAnonymousID') as string;
  const data = {
    anonymousId,
    ext_data: {
      product_name: currPageInfo.category,
    },
  };
  return Base64.encode(JSON.stringify(data));
};

export { ProductCategory } from './route-info';
